import { render } from "./Meigaranews2.vue?vue&type=template&id=0b042ef9&scoped=true"
import script from "./Meigaranews2.vue?vue&type=script&lang=js"
export * from "./Meigaranews2.vue?vue&type=script&lang=js"

import "./Meigaranews2.vue?vue&type=style&index=0&id=0b042ef9&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b042ef9"]])

export default __exports__